module.exports = __webpack_public_path__ + "img/lens-160-minus-10.43977ba8.png";